import moment from "moment";

export default {
    data:() => {
        return {
            loading:false,
            paginate:{
                current_page:1,
                last_page:1
            }
        }
    },
    methods:{
        formataData(data, hora=false){
            return data?moment(data).format(`DD/MM/YYYY ${hora? 'HH:mm': ''}`):'';
        },
    },
    filters:{
        formataData(data){
            return data?moment(data).format('DD/MM/YYYY'):'';
        },
        formataDataHora(data){
            return data?moment(data).format('DD/MM/YYYY HH:mm'):'';
        },
    }
}